import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HomeService } from '../../../../services/home.service';
import { Item } from '../../../../interfaces/item';
import { Stockitem } from '../../../../interfaces/stockitem';
import { LanguageServiceService } from '../../../../services/language-service.service';
import { LogoutService } from '../../../Authentication/auth/logout.service';
import { BehaviorSubject } from 'rxjs';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { Governorate } from '../../../../interfaces/governorate';
import { GovernoratesService } from '../../../../services/governorates.service';
import { City } from '../../../../interfaces/city';
import { ExcelExportService } from '../../../../services/excel-export.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { PageEvent } from '@angular/material/paginator';
import Swal from 'sweetalert2';
import { UserService } from '../../../../services/user';
import { DeviceDetectorService } from '../../../../services/device-detector.service';
import { PointOfSaleService } from '../../../../services/pos';
import e from 'express';
import { EmployeesService } from '../../../../services/employees';
import { DeliveryService } from '../../../../services/delivery';
import { ItemsService } from '../../../../services/items.service';



@Component({
  selector: 'app-deliverymanagerpage',
  templateUrl: './deliverymanagerpage.component.html',
  styleUrl: './deliverymanagerpage.component.scss'
})
export class DeliverymanagerpageComponent {

  allData: Stockitem[] = [];
  totalItems = 0;

  isAr: boolean = localStorage.getItem("language") == "ar";
  displayedColumns: string[] = [
    'name',
    'national_id',
    'phone',
    'method',
    'actions'
  ];

  imageURL = '/assets/Home.png';
  isActive = true;
  h5Active = false;
  arabicLag = false;
  classToggled: boolean = false;
  contentReady: boolean = true;
  noData: boolean = false;
  searched: boolean = false;
  searchTerm: any = [];
  filterCards: Item[] = [];
  focusOnSreach: boolean = false;
  AllCategoryactive: boolean = true;
  Medicinsactive: boolean = false;
  Injectionsactive: boolean = false;
  WheelChairsactive: boolean = false;
  isFilterDataOpen: boolean = false;
  FilterDataForm!: FormGroup;
  start_date?: string;
  end_date?: string;
  category_id?: number;
  governorates: Governorate[] = [];
  city_id?: number;
  location?: Governorate;
  cities: City[] = [];
  id?: string;
  quantity?: string;
  itemId?: string;
  stockTotal?: string;
  showRejectPopUp: boolean = false;
  isMobile: boolean = false;
  cartPopUp: boolean = false;
  accountType!: string;
  isAdmin!: boolean;
  isSubAdmin!: boolean;
  searchKey: string = '';
  cartItems: any[] = [];
  cartItemCount: number = 0;
  warehouseId!: any;
  allWareHouses: any
  dataSource: MatTableDataSource<any>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  constructor(
    private router: Router,
    private _employessService: EmployeesService,
    private _deliveryhero: DeliveryService,
    private deviceService: DeviceDetectorService,
    private _userService: UserService,
    private _ItemsService: ItemsService,
    private excelExportService: ExcelExportService
  ) {

    this.dataSource = new MatTableDataSource(this.allData);
  }

  ngOnInit(): void {
    this.isMobile = this.deviceService.isMobileDevice();
    this.warehouseId = localStorage.getItem("posId");


    this._userService.getAccountType().subscribe({
      next: (data) => {

        this.accountType = data['user_type'];
        this.isAdmin = this.accountType == "1" || this.accountType == "10";
        this.isSubAdmin = this.accountType == "6";


        this.getAllHeros(this.warehouseId, true, 1);


      },
      error: (error) => console.error(error),
    });
    this._ItemsService.getWearHouses().subscribe({
      next: (res) => {
        this.allWareHouses = res.warehouse
      },
      error: (err) => {

      },
    });

  }

  applyWareHouse(warehouseId: any) {
    this.warehouseId = warehouseId;
    this.getAllHeros(this.warehouseId, true, 1);
  }



  deleteitem(id: string) {

    Swal.fire({
      title: this.isAr ? "متأكد؟؟" : "Are You Sure?",
      showCancelButton: true,
      confirmButtonText: this.isAr ? "اه" : "YES",
      cancelButtonText: this.isAr ? "لا" : "no"
    }).then((result) => {
      if (result.isConfirmed) {
        this.contentReady = true;
        this._deliveryhero.deleteDeliveryStar(id).subscribe({
          next: (res) => {
            this.contentReady = false;
            this.getAllHeros(this.warehouseId, true, 1);
          },
          error: (err) => console.log(err),
        });
      }
    });

  }
  getAllHeros(warehouse: any, hasPagination: boolean, page: any) {
    this.contentReady = true;
    this.searched = false;
    this._deliveryhero.getAllDeliveryStars(warehouse, hasPagination, page).subscribe({
      next: (data) => {
        this.allData = data['data'];
        this.stockTotal = data['total'];
        this.totalItems = data['last_page'];
        this.dataSource = new MatTableDataSource(this.allData);
        this.contentReady = false;

        if (this.allData.length === 0) {
          this.noData = true;
        } else {
          this.noData = false;
        }
      },
      error: (error) => console.error(error),
    });
  }
  showEmployee(itemobj: any) {
    this.router.navigate(['/employee'], { queryParams: itemobj });
  }


  onPaginateChange(event: PageEvent) {
    const newPage = event.pageIndex + 1; // MatPaginator is 0-based
    this.getAllHeros(this.warehouseId, true, newPage);
  }
  edit(itemobj: any) {
    this.router.navigate(['/addemployee'], { queryParams: itemobj });
  }
  formatDate(date: string): string {
    const d = new Date(date);
    const day = d.getDate().toString().padStart(2, '0');
    const month = (d.getMonth() + 1).toString().padStart(2, '0');
    const year = d.getFullYear().toString().slice(2); // Getting last two digits of the year
    return `${day}-${month}-${year}`;
  }
  fixUrl(url: string): string {
    if (!url) return '';

    return url.replace(
      '/storage/',
      '/storage/app/public/'
    );
  }

}
